import { INavLinkProps } from '@belong/types/links';
import { parseNavLink } from '@belong/contentful';
import { AUTHENTICATED_ROUTES, EXTERNAL_ROUTES, ROUTES } from 'src/core/routes';
import { IGetBreadcrumbsProps } from 'src/core/types';
import { matchRoute, getRoutePattern, withoutBasePath, withBasePath } from '@belong/url-utils';

import CategoryModel from './Categories';

export const shouldAddMyservicesLink = (
  path: string,
  routes = [getRoutePattern(AUTHENTICATED_ROUTES.TROUBLESHOOTING)]
): boolean => !!matchRoute(path, routes);

export const prepareBaseBreadcrumbs = (path: string, categories: CategoryModel, homeLink: any): INavLinkProps[] => {
  // always include '/' and '/support'
  const links: INavLinkProps[] = [
    parseNavLink(homeLink) as INavLinkProps,
    { label: categories.root.label, href: ROUTES.HOME }
  ];

  // add 'My Services' link if path matches
  if (shouldAddMyservicesLink(path)) {
    links.push({ label: 'My services', href: EXTERNAL_ROUTES.MY_SERVICES });
  }
  return links;
};

export const getBreadcrumbs = ({ path, categories, homeLink, pageContent }: IGetBreadcrumbsProps): INavLinkProps[] => {
  if (!pageContent) {
    return [];
  }

  const { article } = pageContent;
  const links = prepareBaseBreadcrumbs(path, categories, homeLink);

  // generate breadcrumbs for current page
  withoutBasePath(path)
    .split('/')
    .filter(Boolean)
    .reduce((url, segment) => {
      const href = `${url}/${segment}`;
      const { pageTitle: label } = categories.getCategoryByPath(href) || {};
      if (label) {
        links.push({ label, href: withBasePath(href) });
      }
      return href;
    }, '');

  // For article pages, add article title to breadcrumbs
  if (article) {
    links.push({ label: article?.title } as INavLinkProps);
  }

  // Assumes last breadcrumb is the active page
  links[links.length - 1].isActive = true;
  links[links.length - 1].href = withBasePath(path);

  return links;
};
